import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index'
Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
  {
    path: "/",
    name: "index",
    component: index,
    children: [
      {
        path: '/',
        component: () => import(/* webpackChunkName: "about" */ '../views/viewData/viewData.vue'),
      },
      {
      path: 'car-brand',
      component: () => import( /* webpackChunkName: "about" */ '../views/car-brand/car-brand.vue'),
    }, {
      path: 'car-series',
      component: () => import( /* webpackChunkName: "about" */ '../views/car-series/car-series.vue'),
    }, {
      path: 'car-model',
      component: () => import( /* webpackChunkName: "about" */ '../views/car-model/car-model.vue'),
    }, {
      path: "account-management",
      component: () => import('../views/account-management/account-management')
    }, {
      path: "car-activities",
      component: () => import('../views/car-activities/car-activities')
    }, {
      path: "car-advertising",
      component: () => import("../views/car-advertising/car-advertising")
    }, {
      path: "car-price-log",
      component: () => import("../views/car-price-log/car-price-log")
    }, {
      path: "car-score",
      component: () => import("../views/car-score/car-score")
    }, {
      path: "car-special-offer",
      component: () => import("../views/car-special-offer/car-special-offer")
    }, {
      path: "car-special-admin",
      component: () => import("../views/car-special-admin/car-special-admin")
    }, {
      path: "car-user-price",
      component: () => import("../views/car-user-price/car-user-price")
    }, {
      path: "car-user-sign",
      component: () => import("../views/car-user-sign/car-user-sign")
    }, {
      path: "car-user-signOne",
      component: () => import("../views/car-user-signOne/car-user-signOne")
    },  {
      path: "car-user-signTwo",
      component: () => import("../views/car-user-signTwo/car-user-signTwo")
    }, {
      path: "car-user",
      component: () => import("../views/car-user/car-user")
    }, {
      path: "car-group",
      component: () => import("../views/car-group/car-group")
    },{
      path:"car-price-log-show",
      component:() => import('../views/car-price-log/show')
    },{
      path:"car-history",
      component:() => import('../views/car-history/history')
    },{
      path:"car-rabking",
      component:()=>import('../views/car-rabking/rabking')
    },{
      path:"/shoppingList",
      component: () => import('../views/luck-draw/shoppingList.vue')
    },{
      path:"/cargoodsList",
      component: () => import('../views/luck-draw/cargoodsList.vue')
    },{
      path:"carDCD",
      component: () => import('../views/carDCD/carDCD.vue')
    },{
      path:"carDCDmodel",
      component: () => import('../views/carDCDmodel/carDCDmodel.vue')
    },{
      path:"carDCDStores",
      component: () => import('../views/carDCDStores/carDCDStores.vue')
    },{
      path:"carDCDList",
      component: () => import('../views/carDCDList/carDCDList.vue')
    }]
  }, {
    path: "/login",
    component: () => import('../views/login/login.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  let storage = window.localStorage;
  let token = storage.getItem("token");
  if (to.path !== '/login') {
    if (token) {
      next()
    } else {
      next('/login')
    }
  } else {
    next()
  }
})


const originalPush = VueRouter.prototype.push
  VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router